export default __webpack_public_path__ + "static/media/padlock.decfb273.svg";